module.exports = __webpack_public_path__ + "img/loading_img.47efe3ae.png";